import { Box, Typography } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { useEffect, useState } from "react";

interface Props {
  label?: string;
  files?: FileList | null;
  existingFiles?: string[];
  onChange: (files: FileList | null) => void;

  // 🔥 NEW
  disabled?: boolean;
}

const MultiUpload = ({
  label = "Upload Other Documents",
  files,
  existingFiles = [],
  onChange,

  // 🔥 NEW
  disabled = false,
}: Props) => {
  //const BASE_URL = process.env.REACT_APP_BASE_URL;
  const BASE_URL = "https://api.ssquarelogic.com/";
  //const BASE_URL = "http://localhost:3012";

  const [previews, setPreviews] = useState<string[]>([]);

  useEffect(() => {
    if (!files) return;

    const urls = Array.from(files).map((file) =>
      URL.createObjectURL(file),
    );

    setPreviews(urls);

    return () => {
      urls.forEach((url) =>
        URL.revokeObjectURL(url),
      );
    };
  }, [files]);

  return (
    <Box sx={{ flex: 1 }}>
      <Box
        component="label"
        sx={{
          height: 70,
          border: "1px dashed #d1d5db",
          borderRadius: "10px",
          background: "#f8fafc",

          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          gap: 1,
          px: 1,

          // 🔥 UPDATED
          cursor: disabled
            ? "default"
            : "pointer",

          overflowX: "auto",

          // 🔥 OPTIONAL
          opacity: disabled ? 0.8 : 1,
        }}
      >
        {/* 🔥 EXISTING FILES */}
        {existingFiles.map((file, index) => (
          <Box
            key={`existing-${index}`}
            sx={{ textAlign: "center" }}
          >
            <img
              src={`${BASE_URL}/uploads/${file}`}
              style={{
                height: 40,
                objectFit: "cover",
              }}
            />

            <Typography
              sx={{
                fontSize: 9,
                maxWidth: 60,
              }}
              noWrap
            >
              {file}
            </Typography>
          </Box>
        ))}

        {/* 🔥 NEW FILES */}
        {files &&
          Array.from(files).map(
            (file, index) => (
              <Box
                key={`new-${index}`}
                sx={{ textAlign: "center" }}
              >
                <img
                  src={previews[index]}
                  style={{
                    height: 40,
                    objectFit: "cover",
                  }}
                />

                <Typography
                  sx={{
                    fontSize: 9,
                    maxWidth: 60,
                  }}
                  noWrap
                >
                  {file.name}
                </Typography>
              </Box>
            ),
          )}

        {/* 🔥 PLACEHOLDER */}
        {!files &&
          existingFiles.length === 0 && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <UploadFile
                sx={{ fontSize: 18 }}
              />

              <Typography
                sx={{ fontSize: 10 }}
              >
                {label}
              </Typography>
            </Box>
          )}

        {/* 🔥 INPUT */}
        <input
          hidden
          disabled={disabled}
          type="file"
          multiple
          onChange={(e) =>
            onChange(e.target.files)
          }
        />
      </Box>
    </Box>
  );
};

export default MultiUpload;